import { render, staticRenderFns } from "./WebHeader.vue?vue&type=template&id=64ec74a6&lang=html&"
import script from "./WebHeader.vue?vue&type=script&lang=js&"
export * from "./WebHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64ec74a6')) {
      api.createRecord('64ec74a6', component.options)
    } else {
      api.reload('64ec74a6', component.options)
    }
    module.hot.accept("./WebHeader.vue?vue&type=template&id=64ec74a6&lang=html&", function () {
      api.rerender('64ec74a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/WebHeader.vue"
export default component.exports